import UmlShape from './UmlShape';

// Sequence-diagram lifeline header box — participant name + namespace, no
// members/constructor (unlike UmlClassShape). Lives as a package child (see
// CsSeqCanvasLayoutBuilder), individually draggable like any other child shape.
// The BOTTOM duplicate row (standard sequence-diagram convention) sets
// linkedParticipantId to the TOP participant's id instead — that copy then
// tracks the top one's live x (see UmlSeqParticipantWidget) instead of being
// independently draggable, same reasoning as UmlSeqLifelineShape.
// isActor renders as a UML stick-figure instead of a header box (see
// UmlSeqParticipantWidget) — set for the synthetic external-caller
// participant CsSeqShapeFactory prepends to every sequence diagram, and
// never lives inside a package (no namespace).
class UmlSeqParticipantShape extends UmlShape {
  constructor(id, x, y, w, h, name, namespace, linkedParticipantId = null, isActor = false) {
    super(id, x, y, w, h);
    this.name = name;
    this.namespace = namespace || null;
    this.linkedParticipantId = linkedParticipantId;
    this.isActor = Boolean(isActor);
    this.kind = 'seq-participant'; // discriminant voor UmlShapeSerializer.fromPlainShape
  }
}

export default UmlSeqParticipantShape;
